export default __webpack_public_path__ + "static/sportswearHeader-f89dc806a4af1e14fd6f53f301875dd8.jpg";